import { combineReducers, configureStore } from '@reduxjs/toolkit';
import appReducer from '../../features/app/reducers/appSlice';
import assetsReducer from '../../features/app/reducers/assets/assetsSlice';
import { baseApi } from '../../features/services/baseApi';
import langReducer from '../lang/langSlice';
import loginReducer from '../login/loginSlice';
import tokenHandlingReducer from '../tokenHandling/tokenHandlingSlice';

export const rootReducer = combineReducers({
    lang: langReducer,
    app: appReducer,
    login: loginReducer,
    tokenHandling: tokenHandlingReducer,
    assets: assetsReducer,
    [baseApi.reducerPath]: baseApi.reducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) =>
    configureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware => getDefaultMiddleware().concat(baseApi.middleware),
        preloadedState: preloadedState,
    });

export const store = setupStore();

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch'];
